import React from 'react';
import { FaArrowUp, FaArrowDown } from 'react-icons/fa';
import styled from '@emotion/styled';

// Extend the Flex styled component to handle direction and align as props
const Flex = styled.div`
  display: flex;
  flex-direction: ${({ direction }) => direction || 'row'};
  justify-content: ${({ justify }) => justify || 'flex-start'};
  align-items: ${({ align }) => align || 'center'};
  gap: ${({ gap }) => (gap ? `${gap}px` : '0')};
`;

const BalanceWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  height: 24px;
  background-color: #EFFBFF;
  border-radius: 8px;
  padding: 0 4px;
  cursor: pointer;
`;

const BalanceAmount = styled.p`
  font-size: 0.875rem;
  font-weight: 600;
  line-height: 1; /* Line height 1 to tightly pack */
  margin-top: 26px; /* Remove any default margins */
  color: ${({ trend }) =>
    trend === 'up' ? '#16a34a' : trend === 'down' ? '#dc2626' : '#111827'};
  display: flex;
  align-items: center;
`;

const TrendIconWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-top: 8px;
`;

const UserBalance = ({
  balance,
  trend = 'up',
}) => {
  // Format number without currency symbol
  const formattedBalance = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(balance);

  const TrendIcon = trend === 'up' ? FaArrowUp : trend === 'down' ? FaArrowDown : null;

  return (
    <BalanceWrapper >
          <BalanceAmount trend={trend}> RS {formattedBalance}</BalanceAmount>
          {/* {TrendIcon && (
            <TrendIconWrapper>
              <TrendIcon 
                size={12} 
                color={trend === 'up' ? '#16a34a' : '#dc2626'}   
              />
            </TrendIconWrapper>
          )} */}
    </BalanceWrapper>
  );
};
export default UserBalance;
